<template>
  <MultipleFlows
    v-if="multi?.entities"
    flow-type="contributions"
    :entities="multi?.entities?.value"
    :restrictions
  />
  <div
    v-else
    class="wizzard__form"
  >
    <Flows
      :flows="contributions"
      :restrictions
      @submit="handleSubmit"
      @remove="handleRemove"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { orderBy } from 'lodash'

import { TransactionClass } from '@types'

import { NOTIFICATION_DELAY, TRANSACTION_FIELD } from '@/const'
import { MULTI_ENTITY_CONTEXT } from '../utils/const'
import {
  CONTRIBUTION_TYPES,
  CONTRIBUTION_TYPES_NO_DRAWDOWN,
} from './utils/const'

import { useNotifications } from '@/plugins/notification'

import Flows from './components/Flows.vue'
import MultipleFlows from './components/MultipleFlows.vue'

type Props = {
  isNoDrawdown: boolean
  transaction?: TransactionClass
}

const props = defineProps<Props>()

const contributions = defineModel<TransactionClass[]>('contributions', {
  required: true,
})

defineOptions({ inheritAttrs: false })

const { warn } = useNotifications()

const multi = inject(MULTI_ENTITY_CONTEXT)

const restrictions = computed(() => {
  return props.isNoDrawdown
    ? CONTRIBUTION_TYPES_NO_DRAWDOWN
    : CONTRIBUTION_TYPES
})

const handleSubmit = (data: TransactionClass) => {
  contributions.value?.push(data)
  checkInvestmentDate()
}

const handleRemove = (index: number) => {
  contributions.value?.splice(index, 1)
  checkInvestmentDate()
}

const checkInvestmentDate = () => {
  const erliestDate = orderBy(contributions.value, item => item.field(TRANSACTION_FIELD.DATE).value, ['asc'])?.at(0)?.field(TRANSACTION_FIELD.DATE).value
  const currentDate = props.transaction?.field(TRANSACTION_FIELD.DATE).value
  if (props.transaction && erliestDate && erliestDate !== currentDate) {
    props.transaction.field(TRANSACTION_FIELD.DATE).value = erliestDate
    warn({ message: 'The investment date has been updated to the earliest date of the contributions' }, NOTIFICATION_DELAY)
  }
}
</script>
